import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageBanner from "../components/PageBanner";
import QuoteBand from "../components/QuoteBand";
import Reveal from "../components/Reveal";
import { news } from "../mock";

export default function News() {
  return (
    <div className="bg-white" data-testid="news-page">
      <PageBanner
        title="Bizden Haberler"
        subtitle="Projelerimiz ve şantiyelerimizden güncel gelişmeler."
        breadcrumbs={[{ label: "Bizden Haberler" }]}
        image="/images/slider/slider2.jpg"
      />
      <section className="py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="grid md:grid-cols-3 gap-px bg-brand-line">
            {news.map((n, i) => (
              <Reveal key={n.slug} delay={(i % 3) * 110}>
                <Link
                  to={`/haber/${n.slug}`}
                  data-testid={`news-list-card-${n.slug}`}
                  className="group flex flex-col h-full bg-white hover:shadow-[0_28px_50px_-28px_rgba(15,56,122,0.35)] transition-[box-shadow,transform] duration-500 hover:-translate-y-1"
                >
                  <div className="frame relative aspect-[16/10] overflow-hidden">
                    <img
                      src={n.image}
                      alt={n.title}
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-[1100ms] ease-out group-hover:scale-[1.07]"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/60 to-transparent" />
                    <span className="absolute bottom-4 left-5 font-mono text-[10px] uppercase tracking-[0.2em] text-white/85">{n.date}</span>
                  </div>
                  <div className="p-7 flex flex-col flex-1">
                    <h3 className="font-display text-[17px] font-medium tracking-[-0.02em] text-brand-ink group-hover:text-brand-accent transition-colors duration-300">
                      {n.title}
                    </h3>
                    <p className="mt-3 text-[13.5px] text-brand-muted leading-relaxed font-light line-clamp-4 flex-1">{n.excerpt}</p>
                    <span className="mt-6 pt-5 border-t border-brand-line-soft inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-brand-accent">
                      Devamını Oku <ArrowUpRight className="w-3.5 h-3.5" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <QuoteBand />
    </div>
  );
}
